var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"mode":"file","items":_vm.files},on:{"load":_vm.onLoad,"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }